import { Component } from 'react';
import { inject } from 'mobx-react';

@inject('oidcStore')
class AutoLogin extends Component {

    componentWillMount() {

        this.props.oidcStore.startLogin();
    }
    
    render() {
            
        return null;
    }
}

export default AutoLogin;


// WEBPACK FOOTER //
// ./src/components/account/autoLogin.jsx